import AppDispatcher from "../dispatcher/AppDispatcher"
import { EventEmitter } from "events"
import Constants from "../constants/Constants"
import assign from "object-assign"

import Supplier from "../vo/Supplier"


var CHANGE_EVENT = "change"

var _item = null
var _items = []


const setList = (items) => {
  _items = items.map( item => {
    return Supplier(item)
  })
}

const update = (name,value) => {
  _item = _item.set(name, value)
}

const setItem = (item) => {
  _item = item
}


var SupplierStore = assign({},EventEmitter.prototype,{

  getList(){
    return _items
  },

  getItem(){
    return _item
  },



  emitChange(str =  CHANGE_EVENT){ // 何かアクションがあったことを知らせる
    this.emit(str)
  },

  addChangeListener(callback,str =  CHANGE_EVENT){ // リスナーに追加
    this.on(str, callback)
  },

  removeChangeListener(callback,str =  CHANGE_EVENT){ // リスナーから削除
    this.removeListener(str, callback)
  },


})

AppDispatcher.register((action)=>{

  switch(action.actionType){ // actionTypeでswitchする
    case Constants.SUPPLIER_LIST_LOADED:
      setList(action.list);
      SupplierStore.emitChange()
    break;
    case Constants.SUPPLIER_UPDATE:
      update(action.name,action.value);
      SupplierStore.emitChange()
    break;
    case Constants.SUPPLIER_SET_ITEM:
      setItem(action.item);
      SupplierStore.emitChange()
    break;

    default:
  }


})
export default SupplierStore
